interface SummaryCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  icon?: any;
  emphasis?: 'default' | 'featured';
}

const SummaryCard = (props: SummaryCardProps) => {
  const { label, value, subtext, icon, emphasis = 'default' } = props;
  const isFeatured = emphasis === 'featured';
  return (
    <div className={`summary-card group transition-colors ${isFeatured ? 'p-6 lg:p-7' : 'p-5'} hover:border-slate-300`}>
      <div className="mb-4 flex items-start justify-between gap-4">
        <div className={`rounded-xl border border-slate-200 text-slate-500 transition-colors ${isFeatured ? 'p-3 bg-slate-50' : 'p-2.5 bg-slate-50'}`}>
          {icon}
        </div>
        <div className={`text-right ${isFeatured ? 'text-sm font-medium text-slate-500' : 'text-sm font-medium text-slate-500'}`}>{label}</div>
      </div>
      <div className="flex flex-col gap-2">
        <div className={`${isFeatured ? 'text-3xl lg:text-[2.3rem]' : 'text-2xl'} font-semibold text-slate-900`}>{value}</div>
        {subtext && <div className="text-sm leading-6 text-slate-500">{subtext}</div>}
      </div>
    </div>
  );
};

export default SummaryCard;
